import SearchForm from './components/SearchForm/SearchForm.css';
export default {
    SearchForm: {
        SearchForm: {
            row: SearchForm.searchFormOnly__row
        }
    }
};
